import React from 'react'
import { splitAndGetHead, splitAndGetLast } from 'root/src/shared/util/ramdaPlus'
import pipe from 'ramda/src/pipe'
import prop from 'ramda/src/prop'
import __ from 'ramda/src/__'
import { useWindowSize } from 'root/src/client/v2/common/hooks/useWindowSize'
import mediaMimeTypes from 'root/src/shared/constants/mediaMimeTypes'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { addHttpsProtocol } from 'root/src/shared/util/protocolUtil'

const responsiveBreakpoint = 500

export default ({ imageObj, className, alt, children, imageWidth, controls, thumbnail }) => {
	const [width] = useWindowSize()
	const isMobile = width < responsiveBreakpoint
	const { desktop, mobile } = imageObj
	const asset = isMobile ? mobile : desktop
	const assetType = asset ? pipe(
		splitAndGetLast('.'),
		prop(__, mediaMimeTypes),
		splitAndGetHead('/'),
	)(asset) : undefined

	return assetType === 'image'
		? (children ? (
			<div
				style={{ backgroundImage: `url(${addHttpsProtocol(asset)})` }}
				className={className}
			>
				{children}
			</div>
		)
			: (
				<LazyLoadImage
					src={addHttpsProtocol(isMobile ? mobile : desktop)}
					className={className}
					alt={alt}
				/>
			))
		: assetType === 'video'
			? (
				<video
					className={className}
					style={{ width: imageWidth }}
					muted
					playsInline
					src={asset}
					controls={controls}
					{...(thumbnail
						? ({
							preload: 'metadata',
						})
						: ({
							autoPlay: true,
							loop: true,
						}))
					}
				/>
			)
			: null
}
